// TODO alias 路径
import type { EnumValueType } from '../../EnumUtils'
import { EnumUtils } from '../../EnumUtils'

/**
 * 支付类型常量
 */
export const PayTypeConstants = {
  WX_MINI_PROGRAM: { value: 1, label: '微信小程序支付' },
  WX_NATIVE: { value: 2, label: '微信native支付' },
  WX_MICRO: { value: 3, label: '微信付款码支付' },
  WX_H5: { value: 4, label: '微信H5支付' },
  // 微信jsapi支付
  WX_JSAPI: { value: 5, label: '微信支付' },
  // 微信APP支付
  WX_APP: { value: 6, label: '微信APP支付' },
  ALI_NATIVE: { value: 7, label: '支付宝native支付' },
  ALI_H5: { value: 8, label: '支付宝H5支付' },
  ALI_APP: { value: 9, label: '支付宝APP支付' },
  ALI_TRADE: { value: 10, label: '支付宝当面付' },
  ALI_WEB: { value: 11, label: '支付宝网页支付' },
  SQB: { value: 12, label: '收钱吧' },
} as const

export type PayTypeValue = EnumValueType<typeof PayTypeConstants>

export const payTypeEnumUtils = new EnumUtils<PayTypeValue>(PayTypeConstants)

/**
 * 支付渠道常量
 */
export const PaymentConstants = {
  WX_PAY: { value: 1, label: '微信支付' },
  ALI_PAY: { value: 2, label: '支付宝支付' },
} as const

export type PaymentValue = EnumValueType<typeof PaymentConstants>

export const paymentEnumUtils = new EnumUtils<PaymentValue>(PaymentConstants)

/**
 * 退款类型常量
 */
export const RefundTypeConstants = {
  REFUND_SUCCESS: { value: 1, label: '退款成功' },
  REFUNDING: { value: 2, label: '退款中' },
  REFUND_FAILED: { value: 3, label: '退款失败' },
  CANCEL: { value: 4, label: '已取消' },
} as const

export type RefundTypeValue = EnumValueType<typeof RefundTypeConstants>

export const refundTypeEnumUtils = new EnumUtils<RefundTypeValue>(RefundTypeConstants)
